<template>
  <footer>
    <a
      href="https://github.com/joaoquinto"
      target="_blank"
      rel="noopener noreferrer"
      >joaoquinto © 2024</a
    >
  </footer>
</template>

<script>
export default {
  name: "FooterVue",
};
</script>

<style scoped>
footer {
  width: 100%;
  padding: 0.625rem 0;
  margin: 0 auto;
  text-align: center;
}

footer a {
  color: var(--color-text);
  font-family: "Montserrat";
  font-size: var(--fs-text-1);
  transition: color 0.1s;
}

a:hover {
  color: #707070;
}
</style>
